var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEarthshareDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_305_7818)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "#398896"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1889.76 52.8296C1888.87 52.8296 1888.42 53.9067 1889.05 54.5367L1890.39 55.8725C1890.78 56.263 1891.41 56.263 1891.8 55.8725L1893.14 54.5367C1893.77 53.9067 1893.32 52.8296 1892.43 52.8296H1889.76Z",
    fill: "#AAB3BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2058.5 -30.8502C1904.25 6.18444 1814.29 71.9219 1759.62 128.518C1714.05 175.703 1711.51 197.4 1665.6 230.831C1565.98 303.375 1390.75 337.541 1321.01 252.073C1286.65 209.972 1308.18 166.303 1302.09 76.6642C1296.62 -3.97254 1268.39 -117.957 1162.33 -253.058",
    stroke: "white",
    strokeOpacity: 0.35,
    strokeWidth: 0.774062,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2055.39 -11.956C1906.35 17.4194 1817.85 78.6874 1763.82 131.225C1718.35 175.446 1712.28 194.933 1663.99 227.316C1562.67 295.25 1397.93 328.521 1327.35 247.954C1290.99 206.457 1307.16 162.794 1297.78 72.9238C1289.51 -6.19734 1260.11 -118.48 1156.02 -252.217",
    stroke: "white",
    strokeOpacity: 0.35,
    strokeWidth: 0.774062,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2052.28 6.93575C1908.45 28.6548 1821.36 85.4628 1768 133.932C1722.55 175.223 1713.13 192.479 1662.37 223.801C1559.54 287.248 1404.85 319.596 1333.67 243.835C1295.22 202.904 1306.2 159.339 1293.45 69.1845C1282.47 -8.39089 1251.81 -118.996 1149.68 -251.365",
    stroke: "white",
    strokeOpacity: 0.35,
    strokeWidth: 0.774062,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2049.17 25.8299C1910.54 39.8926 1824.78 92.245 1772.18 136.654C1726.69 175.043 1714.04 190.054 1660.73 220.28C1556.57 279.376 1411.5 310.782 1339.99 239.712C1299.36 199.336 1305.3 155.93 1289.11 65.4412C1275.52 -10.5549 1243.51 -119.514 1143.36 -250.52",
    stroke: "white",
    strokeOpacity: 0.35,
    strokeWidth: 0.774062,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2046.06 44.7217C1912.63 51.1209 1828.11 99.0143 1776.36 139.347C1730.75 174.895 1715 187.659 1659.13 216.767C1553.76 271.64 1417.95 302.097 1346.34 235.594C1303.43 195.751 1304.49 152.557 1284.8 61.7017C1268.67 -12.698 1235.23 -120.03 1137.06 -249.66",
    stroke: "white",
    strokeOpacity: 0.35,
    strokeWidth: 0.774062,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2042.95 63.6135C1914.74 62.3579 1831.35 105.772 1780.55 142.054C1734.73 174.779 1716.05 185.316 1657.51 213.248C1551.07 264.041 1424.16 293.542 1352.67 231.475C1307.4 192.174 1303.77 149.212 1280.47 57.9601C1261.89 -14.8326 1226.93 -120.546 1130.74 -248.828",
    stroke: "white",
    strokeOpacity: 0.35,
    strokeWidth: 0.774062,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2039.84 82.5051C1916.84 73.58 1834.47 112.485 1784.73 144.76C1738.61 174.686 1717.13 183.021 1655.89 209.733C1548.48 256.576 1430.18 285.129 1359 227.355C1311.28 188.622 1303.1 145.876 1276.14 54.2211C1255.2 -16.9658 1218.63 -121.064 1124.42 -247.98",
    stroke: "white",
    strokeOpacity: 0.35,
    strokeWidth: 0.774062,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2036.72 101.398C1918.92 84.8245 1837.47 119.15 1788.9 147.465C1742.37 174.597 1718.24 180.783 1654.26 206.216C1545.97 249.243 1436 276.856 1365.32 223.232C1315.06 185.106 1302.53 142.548 1271.81 50.4781C1248.6 -19.0992 1210.35 -121.57 1118.1 -247.134",
    stroke: "white",
    strokeOpacity: 0.35,
    strokeWidth: 0.774062,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2033.62 120.291C1921.03 96.0612 1840.35 125.74 1793.1 150.176C1746.03 174.504 1719.42 178.631 1652.65 202.698C1543.54 242.039 1441.68 268.734 1371.66 219.115C1318.77 181.646 1302.06 139.21 1267.49 46.7379C1242.07 -21.2461 1202.06 -122.096 1111.76 -246.291",
    stroke: "white",
    strokeOpacity: 0.35,
    strokeWidth: 0.774062,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2030.51 139.175C1923.13 107.288 1843.1 132.221 1797.28 152.874C1749.58 174.372 1720.62 176.509 1651.03 199.175C1541.17 234.95 1447.23 260.747 1377.99 214.987C1322.41 178.25 1301.68 135.843 1263.16 42.9883C1235.62 -23.4191 1193.76 -122.621 1105.46 -245.452",
    stroke: "white",
    strokeOpacity: 0.35,
    strokeWidth: 0.774062,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2027.4 158.077C1925.21 118.53 1845.72 138.597 1801.46 155.589C1753 174.195 1721.84 174.489 1649.4 195.664C1538.83 227.991 1452.65 252.922 1384.32 210.877C1325.96 174.96 1301.39 132.461 1258.84 39.255C1229.23 -25.5976 1185.47 -123.128 1099.14 -244.593",
    stroke: "white",
    strokeOpacity: 0.35,
    strokeWidth: 0.774062,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2024.29 176.969C1927.32 129.764 1848.23 144.819 1805.64 158.295C1756.3 173.911 1723.07 172.536 1647.78 192.149C1536.51 221.131 1457.97 245.226 1390.65 206.756C1329.43 171.77 1301.18 129.03 1254.51 35.5158C1222.9 -27.8134 1177.17 -123.647 1092.82 -243.75",
    stroke: "white",
    strokeOpacity: 0.35,
    strokeWidth: 0.774062,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2021.18 195.863C1929.42 141 1850.64 150.877 1809.83 161.004C1759.5 173.489 1724.33 170.662 1646.16 188.633C1534.2 214.373 1463.22 237.67 1396.98 202.635C1332.84 168.709 1301.06 125.55 1250.18 31.7743C1216.63 -30.0609 1168.88 -124.163 1086.5 -242.905",
    stroke: "white",
    strokeOpacity: 0.35,
    strokeWidth: 0.774062,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2018.07 214.755C1931.52 152.235 1852.98 156.758 1814.01 163.71C1762.62 172.878 1725.58 168.864 1644.55 185.115C1531.91 207.705 1468.42 230.232 1403.32 198.517C1336.17 165.793 1301.03 122.008 1245.86 28.0334C1210.41 -32.3475 1160.59 -124.687 1080.18 -242.052",
    stroke: "white",
    strokeOpacity: 0.35,
    strokeWidth: 0.774062,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2014.96 233.647C1933.62 163.468 1855.29 162.454 1818.2 166.419C1765.7 172.029 1726.85 167.143 1642.93 181.6C1529.6 201.124 1473.58 222.947 1409.65 194.397C1339.46 163.048 1301.07 118.4 1241.54 24.2849C1204.24 -34.6791 1152.3 -125.204 1073.87 -241.221",
    stroke: "white",
    strokeOpacity: 0.35,
    strokeWidth: 0.774062,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2011.85 252.541C1935.7 174.701 1857.59 167.968 1822.37 169.124C1768.77 170.885 1728.09 165.496 1641.3 178.081C1527.28 194.629 1478.71 215.77 1415.97 190.278C1342.68 160.489 1301.18 114.725 1237.2 20.5526C1198.08 -37.0416 1144 -125.713 1067.54 -240.366",
    stroke: "white",
    strokeOpacity: 0.35,
    strokeWidth: 0.774062,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2008.73 271.431C1937.8 185.937 1858.15 182.742 1826.54 171.831C1774.84 153.981 1729.31 163.925 1639.67 174.563C1524.92 188.185 1483.85 208.712 1422.3 186.157C1345.86 158.15 1301.35 110.951 1232.88 16.8108C1191.96 -39.4468 1135.71 -126.229 1061.22 -239.511",
    stroke: "white",
    strokeOpacity: 0.35,
    strokeWidth: 0.774062,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2005.63 290.324C1939.91 197.173 1860.46 186.223 1830.74 174.539C1778.65 154.062 1730.56 162.428 1638.06 171.049C1522.55 181.824 1489.02 201.773 1428.64 182.036C1349.02 156.03 1301.59 107.105 1228.55 13.064C1185.85 -41.9053 1127.41 -126.753 1054.9 -238.681",
    stroke: "white",
    strokeOpacity: 0.35,
    strokeWidth: 0.774062,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2002.52 309.218C1942.01 208.406 1863.18 189.457 1834.92 177.246C1782.18 154.454 1731.77 161.002 1636.44 167.543C1520.15 175.51 1494.22 194.929 1434.96 177.931C1352.16 154.178 1301.87 103.184 1224.22 9.34051C1179.76 -44.3836 1119.12 -127.256 1048.58 -237.818",
    stroke: "white",
    strokeOpacity: 0.35,
    strokeWidth: 0.774062,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1999.41 328.11C1944.1 219.641 1867.83 188.645 1839.1 179.952C1782.51 162.846 1732.96 159.639 1634.82 164.022C1517.7 169.241 1499.48 188.172 1441.29 173.805C1355.32 152.569 1302.21 99.1409 1219.89 5.58509C1173.68 -46.9383 1110.82 -127.78 1042.26 -236.986",
    stroke: "white",
    strokeOpacity: 0.35,
    strokeWidth: 0.774062,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1996.3 347.002C1946.2 230.876 1870.83 193.645 1843.29 182.661C1786.67 160.081 1734.13 158.344 1633.2 160.504C1515.23 163.021 1504.83 181.509 1447.63 169.684C1358.49 151.26 1302.57 95.0433 1215.57 1.85194C1167.61 -49.5185 1102.53 -128.29 1035.94 -236.132",
    stroke: "white",
    strokeOpacity: 0.35,
    strokeWidth: 0.774062,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1993.19 365.896C1948.3 242.111 1874.07 198.686 1847.47 185.367C1791.19 157.176 1735.27 157.109 1631.58 156.983C1512.71 156.838 1510.27 174.92 1453.96 165.56C1361.71 150.218 1302.97 90.8385 1211.24 -1.89267C1161.53 -52.1367 1094.24 -128.814 1029.62 -235.292",
    stroke: "white",
    strokeOpacity: 0.35,
    strokeWidth: 0.774062,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_305_7818"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarthshareDashboard);
export default __webpack_public_path__ + "static/media/earthshare_dashboard.a4b2cf82baa76eea730d250ef30fb982.svg";
export { ForwardRef as ReactComponent };